(function () {
  const DAY_KEYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']; // getDay(): 0=Dom
  const DAY_LABELS = { sun: 'Dom.', mon: 'Lun.', tue: 'Mar.', wed: 'Mié.', thu: 'Jue.', fri: 'Vie.', sat: 'Sáb.' };

  // Orden y etiquetas para construir cards/modales (Lunes → Domingo).
  const BUILD_DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
  const BUILD_DAY_LABELS = {
    mon: 'Lunes',
    tue: 'Martes',
    wed: 'Miércoles',
    thu: 'Jueves',
    fri: 'Viernes',
    sat: 'Sábado',
    sun: 'Domingo',
  };
  const SCHEMA_DAYS = {
    mon: 'Monday',
    tue: 'Tuesday',
    wed: 'Wednesday',
    thu: 'Thursday',
    fri: 'Friday',
    sat: 'Saturday',
    sun: 'Sunday',
  };

  function getSantiagoNow() {
    // Hora actual en America/Santiago, sin depender de la TZ del navegador.
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Santiago',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(new Date());
    const wd = parts
      .find((p) => p.type === 'weekday')
      .value.toLowerCase()
      .slice(0, 3);
    const hour = parseInt(parts.find((p) => p.type === 'hour').value, 10);
    const minute = parseInt(parts.find((p) => p.type === 'minute').value, 10);
    const map = { sun: 0, mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6 };
    return { dayIdx: map[wd], minutes: hour * 60 + minute };
  }

  function toMin(hhmm) {
    const [h, m] = hhmm.split(':').map(Number);
    return h * 60 + m;
  }

  // Normaliza texto para el buscador: minúsculas y sin acentos.
  function normalizeText(s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '');
  }

  // Escapa datos interpolados en strings HTML (metaobject data es admin-controlled,
  // pero escapamos igual). Sirve para contenido de texto y valores de atributos.
  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // Cadena "calle, comuna, región, Chile" codificada para URLs de Google Maps.
  function destEnc(store) {
    return encodeURIComponent(`${store.street}, ${store.locality}, ${store.region}, Chile`);
  }

  // Misma regla que el Liquid original: map_embed > lat/long > dirección codificada.
  function buildMapSrc(store) {
    if (store.map_embed) return store.map_embed;
    if (store.latitude && store.longitude) {
      return `https://maps.google.com/maps?q=${store.latitude},${store.longitude}&z=15&output=embed`;
    }
    return `https://maps.google.com/maps?q=${destEnc(store)}&z=15&output=embed`;
  }

  // Aplana node.fields (array {key,value}) a un objeto plano de tienda + imagen + horarios.
  function parseNode(node) {
    const f = {};
    (node.fields || []).forEach((fl) => {
      if (fl && fl.key != null) f[fl.key] = fl.value;
    });
    const val = (k) => (f[k] != null ? f[k] : '');
    const name = val('name');
    const type = val('type') === 'store' ? 'store' : 'pickup';
    // La URL de la imagen vive en un field de texto `image_url` porque el
    // Storefront API no resuelve la referencia file_reference con el scope
    // unauthenticated_read_metaobjects (reference queda null).
    const store = {
      handle: node.handle || '',
      name,
      type,
      street: val('street'),
      locality: val('locality'),
      region: val('region'),
      latitude: val('latitude'),
      longitude: val('longitude'),
      phone: val('phone'),
      map_embed: val('map_embed'),
      image_url: val('image_url'),
      image_alt: name,
    };
    const hours = {};
    BUILD_DAYS.forEach((d) => {
      if (type !== 'store') {
        hours[d] = null;
        return;
      }
      const o = f[`hours_${d}_open`];
      const c = f[`hours_${d}_close`];
      hours[d] = o && c ? [o, c] : null;
    });
    store.hours = hours;
    return store;
  }

  // Sirve la imagen del CDN de Shopify a un ancho acotado (perf): agrega ?width=.
  function imgSrc(url, w) {
    if (!url) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  // Card <li>: tienda física (con status/Ver más/horarios) o pickup (sin ellos).
  function cardMarkup(store, isFirst) {
    const isStore = store.type === 'store';
    const cls = isStore ? `store-card${isFirst ? ' is-active' : ''}` : 'store-card store-card--pickup';
    const media = store.image_url
      ? `<div class="store-card__media"><img src="${escapeHtml(imgSrc(store.image_url, 400))}" loading="lazy" alt="${escapeHtml(
          store.image_alt
        )}"></div>`
      : '';
    const phone = store.phone
      ? `<a class="store-card__phone" href="tel:${escapeHtml(store.phone.replace(/\s+/g, ''))}">${escapeHtml(
          store.phone
        )}</a>`
      : '';
    const dir = `https://www.google.com/maps/dir/?api=1&destination=${destEnc(store)}`;
    const addr = `<p class="store-card__addr">${escapeHtml(store.street)}<br>${escapeHtml(store.locality)}, ${escapeHtml(
      store.region
    )}.</p>`;
    const hit = `<button type="button" class="store-card__hit" data-store-select aria-label="Ver ${escapeHtml(
      store.name
    )} en el mapa"></button>`;

    if (isStore) {
      const links = `<div class="store-card__links"><button type="button" class="link store-card__more" data-modal="#StoreMore-${escapeHtml(
        store.handle
      )}" aria-haspopup="dialog">Ver más</button><a class="link store-card__dir" href="${escapeHtml(
        dir
      )}" target="_blank" rel="noopener noreferrer">Cómo llegar</a></div>`;
      return `<li class="${cls}" data-store data-type="store" data-region="${escapeHtml(
        store.region
      )}" data-locality="${escapeHtml(store.locality)}" data-map-src="${escapeHtml(
        buildMapSrc(store)
      )}" data-hours="${escapeHtml(JSON.stringify(store.hours))}">${media}<div class="store-card__body"><h2 class="store-card__name">${escapeHtml(
        store.name
      )}</h2><p class="store-card__status" data-store-status></p>${addr}${phone}${links}</div>${hit}</li>`;
    }
    const links = `<div class="store-card__links"><a class="link store-card__dir" href="${escapeHtml(
      dir
    )}" target="_blank" rel="noopener noreferrer">Cómo llegar</a></div>`;
    return `<li class="${cls}" data-store data-type="pickup" data-region="${escapeHtml(
      store.region
    )}" data-locality="${escapeHtml(store.locality)}" data-map-src="${escapeHtml(
      buildMapSrc(store)
    )}">${media}<div class="store-card__body"><h2 class="store-card__name">${escapeHtml(
      store.name
    )}</h2>${addr}${links}</div>${hit}</li>`;
  }

  // Modal "Ver más" (solo tiendas físicas): mapa (iframe sin src), datos y tabla de horarios.
  function moreModalMarkup(store) {
    const mapSrc = buildMapSrc(store);
    const dir = `https://www.google.com/maps/dir/?api=1&destination=${destEnc(store)}`;
    const phone = store.phone
      ? `<a class="store-more-modal__phone" href="tel:${escapeHtml(store.phone.replace(/\s+/g, ''))}">${escapeHtml(
          store.phone
        )}</a>`
      : '';
    const rows = BUILD_DAYS.map((d) => {
      const slot = store.hours[d];
      const value = slot ? `${escapeHtml(slot[0])}–${escapeHtml(slot[1])}` : 'Cerrado';
      return `<tr data-day="${d}"><th scope="row">${BUILD_DAY_LABELS[d]}</th><td>${value}</td></tr>`;
    }).join('');
    return `<div id="StoreMore-${escapeHtml(
      store.handle
    )}" class="store-more-modal" data-modal><div class="store-more-modal__content" role="dialog" aria-modal="true" aria-label="${escapeHtml(
      store.name
    )}" tabindex="-1"><button type="button" class="store-more-modal__close" aria-label="Cerrar"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg></button><div class="store-more-modal__map"><iframe class="store-more-modal__iframe" data-map-src="${escapeHtml(
      mapSrc
    )}" title="${escapeHtml(
      store.name
    )}" loading="lazy" referrerpolicy="no-referrer-when-downgrade" allowfullscreen></iframe></div><div class="store-more-modal__info"><h3 class="store-more-modal__name">${escapeHtml(
      store.name
    )}</h3><p class="store-more-modal__addr">${escapeHtml(store.street)}<br>${escapeHtml(store.locality)}, ${escapeHtml(
      store.region
    )}.</p>${phone}<table class="store-more-modal__hours">${rows}</table><a class="link store-more-modal__dir" href="${escapeHtml(
      dir
    )}" target="_blank" rel="noopener noreferrer">Cómo llegar</a></div></div></div>`;
  }

  // Devuelve la palabra clave coloreada (label) por separado del resto del texto
  // (rest), para que solo "Abierto ahora"/"Cerrado" lleve color y el resto quede
  // en negro. updateStatuses arma el <span> con la label + el nodo de texto rest.
  function computeStatus(hours, now) {
    const todayKey = DAY_KEYS[now.dayIdx];
    const today = hours[todayKey];
    if (today && now.minutes >= toMin(today[0]) && now.minutes < toMin(today[1])) {
      return { open: true, label: 'Abierto ahora', rest: ` · Cierra a las ${today[1]}` };
    }
    // Buscar próxima apertura (hoy más tarde, luego siguientes días)
    for (let i = 0; i < 7; i++) {
      const idx = (now.dayIdx + i) % 7;
      const key = DAY_KEYS[idx];
      const slot = hours[key];
      if (!slot) continue;
      const openMin = toMin(slot[0]);
      if (i === 0 && now.minutes < openMin)
        return { open: false, label: 'Cerrado', rest: ` · Abre hoy a las ${slot[0]}` };
      if (i > 0) return { open: false, label: 'Cerrado', rest: ` · Abre ${DAY_LABELS[key]} a las ${slot[0]}` };
    }
    return { open: false, label: 'Cerrado', rest: '' };
  }

  class StoreLocator {
    constructor(root) {
      this.root = root;
      this.token = root.getAttribute('data-sf-token') || '';
      this.version = root.getAttribute('data-sf-version') || '2024-10';
      this.loadingEl = root.querySelector('[data-store-loading]');
      this.errorEl = root.querySelector('[data-store-error]');
      // Cuántas opciones mostrar por grupo antes del botón "Mostrar más" (0 = sin colapsar).
      const vc = parseInt(root.getAttribute('data-filter-visible'), 10);
      this.visibleCount = Number.isFinite(vc) ? vc : 10;
    }

    // Carga: loading → fetch → build → oculta loading → JSON-LD → wire (comportamiento).
    async init() {
      if (this.loadingEl) this.loadingEl.hidden = false;
      if (this.errorEl) this.errorEl.hidden = true;
      let stores = [];
      try {
        stores = await this.fetchStores();
      } catch (e) {
        this.showError();
        return;
      }
      if (!stores.length) {
        this.showError();
        return;
      }
      this.buildDOM(stores);
      if (this.loadingEl) this.loadingEl.hidden = true;
      this.injectJsonLd(stores);
      this.wire();
    }

    showError() {
      if (this.loadingEl) this.loadingEl.hidden = true;
      if (this.errorEl) this.errorEl.hidden = false;
    }

    // Fetch paginado del Storefront API: todas las tiendas (first:250) en orden de API.
    async fetchStores() {
      if (!this.token) return [];
      const version = this.version || '2024-10';
      const query = `query StoreLocations($cursor: String) {
  metaobjects(type: "store_location", first: 250, after: $cursor) {
    nodes {
      handle
      fields { key value }
    }
    pageInfo { hasNextPage endCursor }
  }
}`;
      const stores = [];
      let cursor = null;
      let hasNext = true;
      let guard = 0;
      while (hasNext && guard < 20) {
        guard += 1;
        const res = await fetch(`/api/${version}/graphql.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': this.token,
          },
          body: JSON.stringify({ query, variables: { cursor } }),
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        const mo = json && json.data && json.data.metaobjects;
        if (!mo) throw new Error('Respuesta malformada del Storefront API');
        (mo.nodes || []).forEach((n) => stores.push(parseNode(n)));
        hasNext = !!(mo.pageInfo && mo.pageInfo.hasNextPage);
        cursor = mo.pageInfo && mo.pageInfo.endCursor;
      }
      return stores;
    }

    // Construye cards, modales, opciones de Región/Comuna y el src inicial del mapa.
    buildDOM(stores) {
      // Mostrar primero las tiendas físicas y luego los puntos de retiro (pickup).
      // sort estable: conserva el orden de la API dentro de cada grupo. La primera tienda
      // física queda activa y centra el mapa inicial.
      stores = stores.slice().sort((a, b) => (a.type === 'store' ? 0 : 1) - (b.type === 'store' ? 0 : 1));
      const list = this.root.querySelector('[data-store-list]');
      const modals = this.root.querySelector('[data-more-modals]');
      const regionGroup = this.root.querySelector('[data-region-group]');
      const localityGroup = this.root.querySelector('[data-locality-group]');

      if (list) {
        list.innerHTML = stores.map((s, i) => cardMarkup(s, i === 0)).join('');
      }
      if (modals) {
        modals.innerHTML = stores
          .filter((s) => s.type === 'store')
          .map((s) => moreModalMarkup(s))
          .join('');
      }

      // Región: valores únicos; comuna: valores únicos con su región (primera aparición).
      const regionsSet = new Set();
      const localityRegion = new Map();
      stores.forEach((s) => {
        if (s.region) regionsSet.add(s.region);
        if (s.locality && !localityRegion.has(s.locality)) localityRegion.set(s.locality, s.region);
      });
      // Orden de regiones: RM primero, luego por número romano ascendente (I, II, III…).
      const ROMAN_ORDER = ['RM', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII', 'XIII', 'XIV', 'XV', 'XVI'];
      const regionRank = (r) => {
        const i = ROMAN_ORDER.indexOf(String(r).split('.')[0].trim());
        return i === -1 ? 999 : i;
      };
      const regions = [...regionsSet].sort((a, b) => regionRank(a) - regionRank(b));
      // Comunas: orden alfabético (español).
      const localities = [...localityRegion.keys()].sort((a, b) => a.localeCompare(b, 'es'));
      const regionLabels = regions.map(
        (r) =>
          `<label><input type="checkbox" data-filter name="region" value="${escapeHtml(r)}"> ${escapeHtml(r)}</label>`
      );
      const localityLabels = localities.map(
        (l) =>
          `<label data-region="${escapeHtml(localityRegion.get(l))}"><input type="checkbox" data-filter name="locality" value="${escapeHtml(
            l
          )}"> ${escapeHtml(l)}</label>`
      );
      if (regionGroup) regionGroup.insertAdjacentHTML('beforeend', regionLabels.join(''));
      if (localityGroup) localityGroup.insertAdjacentHTML('beforeend', localityLabels.join(''));

      // Botón "Mostrar más/menos" en grupos que superan el umbral configurable.
      if (this.visibleCount > 0) {
        [regionGroup, localityGroup].forEach((g) => {
          if (g && g.querySelectorAll('label').length > this.visibleCount) {
            g.insertAdjacentHTML(
              'beforeend',
              '<button type="button" class="store-filter-more" data-filter-more aria-expanded="false" hidden></button>'
            );
          }
        });
      }

      const mapIframe = this.root.querySelector('[data-store-map-iframe]');
      if (mapIframe && stores[0]) mapIframe.src = buildMapSrc(stores[0]);
    }

    // JSON-LD ItemList de las tiendas físicas (equivalente al bloque server-side original).
    injectJsonLd(stores) {
      const physical = stores.filter((s) => s.type === 'store');
      const origin = window.location.origin;
      const path = window.location.pathname;
      const itemList = {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        '@id': `${origin}${path}#store-list`,
        name: 'Tiendas Errante85 Chile',
        url: `${origin}${path}`,
        numberOfItems: physical.length,
        itemListElement: physical.map((s, i) => {
          const item = {
            '@type': ['LocalBusiness', 'Store'],
            '@id': `${origin}${path}#${s.handle}`,
            name: s.name,
          };
          if (s.image_url) item.image = s.image_url;
          if (s.phone) item.telephone = s.phone;
          if (s.latitude && s.longitude) {
            item.geo = { '@type': 'GeoCoordinates', latitude: s.latitude, longitude: s.longitude };
          }
          item.address = {
            '@type': 'PostalAddress',
            streetAddress: s.street,
            addressLocality: s.locality,
            addressRegion: s.region,
            addressCountry: 'CL',
          };
          const spec = [];
          BUILD_DAYS.forEach((d) => {
            const slot = s.hours[d];
            if (slot) {
              spec.push({
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: SCHEMA_DAYS[d],
                opens: slot[0],
                closes: slot[1],
              });
            }
          });
          item.openingHoursSpecification = spec;
          return { '@type': 'ListItem', position: i + 1, item };
        }),
      };
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      // Escapamos "<" para no romper el cierre del <script> con datos inesperados.
      script.textContent = JSON.stringify(itemList).replace(/</g, '\\u003c');
      this.root.appendChild(script);
    }

    // Comportamiento (antes cuerpo del constructor): opera sobre el DOM ya construido.
    wire() {
      const root = this.root;
      this.cards = Array.from(root.querySelectorAll('[data-store]'));
      // Índice de búsqueda: nombre + comuna normalizados por card (una sola vez).
      this.searchIndex = new Map();
      this.cards.forEach((card) => {
        const name = card.querySelector('.store-card__name');
        const nameTxt = name ? name.textContent : '';
        const locality = card.getAttribute('data-locality') || '';
        this.searchIndex.set(card, normalizeText(`${nameTxt} ${locality}`));
      });
      this.searchTerm = '';
      this.updateStatuses();
      this.statusTimer = setInterval(() => this.updateStatuses(), 60000);
      // El iframe del markup puede ser barrido por scripts async de terceros
      // (apps / privacy). ensureIframe lo (re)crea en el contenedor y le pone el
      // mapa de la tienda activa. Un MutationObserver lo restaura si desaparece.
      this.mapWrap = root.querySelector('.store-locator__map');
      this.mapReinserts = 0;
      this.ensureIframe = () => {
        if (this.iframe && this.iframe.isConnected) return;
        if (!this.mapWrap) return;
        const created = document.createElement('iframe');
        created.setAttribute('data-store-map-iframe', '');
        created.className = 'store-locator__iframe';
        created.title = 'Mapa de tiendas';
        created.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
        created.setAttribute('allowfullscreen', '');
        created.setAttribute('loading', 'lazy');
        this.mapWrap.appendChild(created);
        this.iframe = created;
        const active = root.querySelector('[data-store].is-active') || this.cards[0];
        if (active) {
          const s = active.getAttribute('data-map-src');
          if (s) created.src = s;
        }
      };
      this.iframe = root.querySelector('[data-store-map-iframe]');
      this.ensureIframe();
      if (this.mapWrap) {
        const mo = new MutationObserver(() => {
          if ((!this.iframe || !this.iframe.isConnected) && this.mapReinserts < 3) {
            this.mapReinserts += 1;
            this.iframe = null;
            this.ensureIframe();
          }
        });
        mo.observe(this.mapWrap, { childList: true });
      }
      this.cards.forEach((card) => {
        const hit = card.querySelector('[data-store-select]');
        if (hit) hit.addEventListener('click', () => this.selectStore(card));
      });
      const firstActive = root.querySelector('[data-store].is-active') || this.cards[0];
      if (firstActive) this.selectStore(firstActive);

      // Modales (Horizon no tiene <modal-opener>/<modal-dialog>): abrimos/cerramos
      // nosotros toggleando el atributo [open] (el CSS anima .store-*-modal[open]).
      this.openModalEl = null;
      this.modalOpener = null;
      this.onModalKeydown = (e) => {
        if (e.key === 'Escape' && this.openModalEl) this.closeModal();
      };
      // Modal "Ver más": el iframe se inyecta SIN src en el markup y se activa
      // al abrir el modal (mucho después de la carga) para sobrevivir al barrido
      // de iframes de Google Maps que hacen scripts async de terceros.
      root.querySelectorAll('[data-modal^="#StoreMore"]').forEach((opener) => {
        opener.addEventListener('click', () => {
          const sel = opener.getAttribute('data-modal');
          const modal = sel && document.querySelector(sel);
          if (!modal) return;
          this.openModal(modal, opener);
          const frame = modal.querySelector('.store-more-modal__iframe');
          if (frame && !frame.getAttribute('src')) {
            const src = frame.getAttribute('data-map-src');
            if (src) frame.setAttribute('src', src);
          }
          this.markTodayRow(modal);
        });
      });
      // Modal FAQ (item 22): el contenido de la página vive en una section con
      // acordeón <details> nativos (page.content está vacío), así que se trae
      // vía fetch al abrir el modal, una sola vez (lazy).
      root.querySelectorAll('[data-modal^="#StoreFaq"]').forEach((opener) => {
        opener.addEventListener('click', () => {
          const sel = opener.getAttribute('data-modal');
          const modal = sel && document.querySelector(sel);
          if (!modal) return;
          this.openModal(modal, opener);
          this.loadFaq(modal);
        });
      });
      // Cierre de modales: botón .close, click en el backdrop (el propio contenedor
      // [data-modal]) y tecla Escape (ver onModalKeydown).
      root.querySelectorAll('.store-more-modal, .store-faq-modal').forEach((modalEl) => {
        modalEl.addEventListener('click', (e) => {
          if (e.target === modalEl) this.closeModal();
        });
        const closeBtn = modalEl.querySelector('.store-more-modal__close, .store-faq-modal__close');
        if (closeBtn) closeBtn.addEventListener('click', () => this.closeModal());
      });

      // Mapa mobile (item 10): en Horizon el header es un custom element con
      // data-sticky-state y semántica de ocultado distinta a Dawn, así que no
      // replicamos el seguimiento de "header oculto". Degradamos: el mapa sticky
      // queda fijo bajo la altura del header (var(--header-height)).
      this.root.style.setProperty('--stores-map-top', 'var(--header-height, 0px)');
      // Guiño de scroll horizontal de la barra de botones (mobile): el CSS pinta
      // un fade en el borde según data-scroll = start | middle | end | none.
      // start → fade a la derecha (hay más); end → fade a la izquierda; middle → ambos.
      this.actionsEl = root.querySelector('.store-locator__actions-track');
      this.updateActionsFade = () => {
        const el = this.actionsEl;
        if (!el) return;
        if (el.scrollWidth <= el.clientWidth + 1) {
          el.dataset.scroll = 'none';
          return;
        }
        const atStart = el.scrollLeft <= 1;
        const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
        el.dataset.scroll = atStart ? 'start' : atEnd ? 'end' : 'middle';
      };
      if (this.actionsEl) {
        this.actionsEl.addEventListener(
          'scroll',
          () => requestAnimationFrame(this.updateActionsFade),
          { passive: true }
        );
        window.addEventListener('resize', () => requestAnimationFrame(this.updateActionsFade));
        this.updateActionsFade();
      }
      // Filtros (Task 7): drawer, filtrado en vivo, contador, borrar, buscador.
      this.drawer = root.querySelector('[data-filter-drawer]');
      this.countEl = root.querySelector('[data-filter-count]');
      this.countLabelEl = root.querySelector('[data-filter-count-label]');
      this.emptyEl = root.querySelector('[data-store-empty]');
      this.filterOpener = null;
      this.onDrawerKeydown = (e) => {
        if (e.key === 'Escape') this.toggleDrawer(false);
      };
      root
        .querySelectorAll('[data-filter-open]')
        .forEach((b) => b.addEventListener('click', () => this.toggleDrawer(true, b)));
      root
        .querySelectorAll('[data-filter-close]')
        .forEach((b) => b.addEventListener('click', () => this.toggleDrawer(false)));
      this.filterInputs = Array.from(root.querySelectorAll('[data-filter]'));
      this.filterInputs.forEach((i) => i.addEventListener('change', () => this.applyFilters()));
      this.searchInput = root.querySelector('[data-store-search]');
      if (this.searchInput) {
        this.searchInput.addEventListener('input', () => {
          this.searchTerm = normalizeText(this.searchInput.value.trim());
          this.applyFilters();
        });
      }
      const clearBtn = root.querySelector('[data-filter-clear]');
      if (clearBtn) {
        clearBtn.addEventListener('click', () => {
          this.filterInputs.forEach((i) => (i.checked = false));
          if (this.searchInput) this.searchInput.value = '';
          this.searchTerm = '';
          this.applyFilters();
        });
      }
      // Toggle "Mostrar más/menos" por grupo.
      root.querySelectorAll('[data-filter-more]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const group = btn.closest('.store-filter-group');
          if (!group) return;
          group.dataset.filterExpanded = group.dataset.filterExpanded === 'true' ? 'false' : 'true';
          this.applyCollapse();
        });
      });
      this.applyFilters();
    }
    openModal(modalEl, opener) {
      if (this.openModalEl === modalEl) return;
      if (this.openModalEl) this.closeModal();
      this.openModalEl = modalEl;
      this.modalOpener = opener || null;
      modalEl.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
      document.addEventListener('keydown', this.onModalKeydown);
      // Horizon expone trapFocus como módulo ES (assets/focus.js), no como global;
      // este es un script clásico, así que usamos focus() nativo.
      const content = modalEl.querySelector('.store-more-modal__content, .store-faq-modal__content') || modalEl;
      content.focus();
    }
    closeModal() {
      const modalEl = this.openModalEl;
      if (!modalEl) return;
      modalEl.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      document.removeEventListener('keydown', this.onModalKeydown);
      const opener = this.modalOpener;
      this.openModalEl = null;
      this.modalOpener = null;
      if (opener) opener.focus();
    }
    toggleDrawer(open, opener) {
      if (!this.drawer) return;
      this.drawer.hidden = !open;
      document.body.classList.toggle('overflow-hidden', open);
      const panel = this.drawer.querySelector('[role="dialog"]');
      if (open) {
        if (opener) this.filterOpener = opener;
        document.addEventListener('keydown', this.onDrawerKeydown);
        // trapFocus no está disponible como global en Horizon: focus() nativo.
        if (panel) panel.focus();
      } else {
        document.removeEventListener('keydown', this.onDrawerKeydown);
        if (this.filterOpener) {
          this.filterOpener.focus();
          this.filterOpener = null;
        }
      }
      this.root
        .querySelectorAll('[data-filter-open]')
        .forEach((b) => b.setAttribute('aria-expanded', open ? 'true' : 'false'));
    }
    getActiveFilters() {
      const f = { type: [], region: [], locality: [] };
      this.filterInputs.filter((i) => i.checked).forEach((i) => f[i.name].push(i.value));
      return f;
    }
    // ¿La tienda tiene este valor para el grupo dado? (type/region/locality: igualdad)
    cardHasValue(card, group, value) {
      if (group === 'type') return card.getAttribute('data-type') === value;
      if (group === 'region') return card.getAttribute('data-region') === value;
      if (group === 'locality') return card.getAttribute('data-locality') === value;
      return false;
    }
    // ¿La tienda pasa los filtros activos? `exceptGroup` omite ese grupo del test
    // (se usa para calcular la disponibilidad de la propia faceta sin que se auto-excluya).
    // El buscador siempre aplica (no es una faceta con checkbox).
    cardMatches(card, f, exceptGroup) {
      const type = card.getAttribute('data-type');
      const region = card.getAttribute('data-region');
      const locality = card.getAttribute('data-locality');
      const okType = exceptGroup === 'type' || !f.type.length || f.type.includes(type);
      const okRegion = exceptGroup === 'region' || !f.region.length || f.region.includes(region);
      const okLocality = exceptGroup === 'locality' || !f.locality.length || f.locality.includes(locality);
      const okSearch = !this.searchTerm || (this.searchIndex.get(card) || '').includes(this.searchTerm);
      return okType && okRegion && okLocality && okSearch;
    }
    // Faceted search: cada checkbox se muestra solo si alguna tienda que pasa las OTRAS
    // facetas tiene ese valor. Una opción ya marcada nunca se oculta (para poder desmarcarla).
    updateFacetAvailability(f) {
      this.filterInputs.forEach((input) => {
        const label = input.closest('label');
        if (!label) return;
        const available = this.cards.some(
          (card) => this.cardMatches(card, f, input.name) && this.cardHasValue(card, input.name, input.value)
        );
        // La comuna depende de la región: una comuna (su <label> lleva data-region)
        // solo se muestra si no hay región activa o si su región está entre las activas.
        let regionOk = true;
        if (input.name === 'locality') {
          const labelRegion = label.getAttribute('data-region');
          regionOk = !f.region.length || f.region.includes(labelRegion);
        }
        label.hidden = (!available || !regionOk) && !input.checked;
      });
      // Si un grupo (fieldset) se queda sin opciones visibles, ocultarlo entero
      // para no dejar el <legend> colgando solo (pasa en el estado de 0 resultados).
      this.root.querySelectorAll('.store-filter-group').forEach((group) => {
        const anyVisible = Array.from(group.querySelectorAll('label')).some((l) => !l.hidden);
        group.hidden = !anyVisible;
      });
      this.applyCollapse();
    }
    // "Mostrar más/menos": colapsa cada grupo a `visibleCount` opciones DISPONIBLES
    // (las no ocultas por faceta), con un botón para expandir/recoger. El conteo se
    // recalcula en cada filtrado porque la disponibilidad de comunas/regiones cambia.
    applyCollapse() {
      if (!(this.visibleCount > 0)) return;
      this.root.querySelectorAll('[data-filter-more]').forEach((btn) => {
        const group = btn.closest('.store-filter-group');
        if (!group) return;
        const labels = Array.from(group.querySelectorAll('label')).filter((l) => !l.hidden);
        const expanded = group.dataset.filterExpanded === 'true';
        const overflow = labels.length - this.visibleCount;
        if (overflow <= 0) {
          btn.hidden = true;
          labels.forEach((l) => l.classList.remove('sl-collapsed'));
          return;
        }
        btn.hidden = false;
        labels.forEach((l, i) => l.classList.toggle('sl-collapsed', !expanded && i >= this.visibleCount));
        btn.textContent = expanded ? '− Mostrar menos' : `+ Mostrar más (${overflow})`;
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }
    applyFilters() {
      const f = this.getActiveFilters();
      const count = f.type.length + f.region.length + f.locality.length;
      let visible = 0;
      this.cards.forEach((card) => {
        const show = this.cardMatches(card, f, null);
        card.hidden = !show;
        if (show) visible++;
      });
      this.updateFacetAvailability(f);
      if (this.countEl) {
        this.countEl.textContent = count;
        this.countEl.hidden = count === 0;
      }
      if (this.countLabelEl) this.countLabelEl.hidden = count === 0;
      if (this.emptyEl) this.emptyEl.hidden = visible !== 0;
      // Si la tienda activa quedó oculta, activar la primera visible.
      const active = this.root.querySelector('[data-store].is-active');
      if (active && active.hidden) {
        const firstVisible = this.cards.find((c) => !c.hidden);
        if (firstVisible) this.selectStore(firstVisible);
      }
    }
    loadFaq(modal) {
      const body = modal.querySelector('[data-faq-body]');
      if (!body || body.dataset.faqState === 'loaded' || body.dataset.faqState === 'loading') return;
      const url = body.getAttribute('data-faq-url');
      if (!url) return;
      body.dataset.faqState = 'loading';
      body.innerHTML = '<p class="store-faq-modal__loading">Cargando…</p>';
      fetch(url)
        .then((res) => {
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          return res.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const content =
            doc.querySelector('#MainContent') || doc.querySelector('main') || doc.querySelector('.shopify-section');
          if (content) {
            body.innerHTML = content.innerHTML;
            body.dataset.faqState = 'loaded';
          } else {
            body.innerHTML = '<p>No se pudo cargar el contenido.</p>';
            body.dataset.faqState = 'error';
          }
        })
        .catch(() => {
          body.innerHTML = '<p>No se pudo cargar el contenido. Intentá de nuevo más tarde.</p>';
          body.dataset.faqState = 'error';
        });
    }
    markTodayRow(modal) {
      const table = modal.querySelector('.store-more-modal__hours');
      if (!table) return;
      const todayKey = DAY_KEYS[getSantiagoNow().dayIdx];
      table.querySelectorAll('tr').forEach((tr) => {
        tr.classList.toggle('is-today', tr.getAttribute('data-day') === todayKey);
      });
    }
    selectStore(card) {
      const src = card.getAttribute('data-map-src');
      if (this.iframe && src && this.iframe.src !== src) this.iframe.src = src;
      this.cards.forEach((c) => c.classList.remove('is-active'));
      card.classList.add('is-active');
    }
    updateStatuses() {
      const now = getSantiagoNow();
      this.cards.forEach((card) => {
        const el = card.querySelector('[data-store-status]');
        if (!el) return;
        let hours;
        try {
          hours = JSON.parse(card.getAttribute('data-hours'));
        } catch (e) {
          return;
        }
        const st = computeStatus(hours, now);
        // Solo la palabra clave (label) va coloreada dentro de un <span>; el
        // resto (rest) queda como nodo de texto negro. Se construye con DOM
        // (no innerHTML) para no inyectar los valores de horario sin escapar.
        el.textContent = '';
        const label = document.createElement('span');
        label.className = `store-card__status-label ${st.open ? 'is-open' : 'is-closed'}`;
        label.textContent = st.label;
        el.appendChild(label);
        if (st.rest) el.appendChild(document.createTextNode(st.rest));
      });
    }
  }

  window.StoreLocator = StoreLocator;
  document.querySelectorAll('[data-store-locator]').forEach((root) => new StoreLocator(root).init());
})();
